import React, { Component } from 'react';
import './cigerate.css';
import Navbar from '../layouts/navbar';
import { HashLink } from 'react-router-hash-link';


class MDMA extends Component {
    componentDidMount(){
        window.scrollTo(0,0);
    }
    render() {
        return (
            <div>
                <Navbar head="MDMA" />
                <div className="container" style={{marginTop:"60px"}}>
                    <HashLink to='/faq#mdma'>
                        <button id="myBtn" title="FAQ">
                            <i class="fas fa-info-circle faqicon"></i>
                            <p>  FAQ</p>
                        </button>
                    </HashLink>

                    <div className="row justify-content-center">
                        <div className="col-12 text-center ">
                        <img className="img-fluid" src="/assests/images/educationMDMA.png" alt="mdma">
                        </img>
                        
                        </div>
                    </div>

                    <div className="content">
                    <h4>What are Hallucinogens? (includes LSD, PCP, MDMA)</h4>
                    <p>Hallucinogens are a diverse group of drugs that alter an individual’s awareness of their surroundings, thoughts and feelings. They can also cause hallucinations which are sensations or images that feel real but are not. Most hallucinogens are either extracted from plants/mushrooms or synthetically developed.</p>
                        <h2>MDMA</h2>
                        <p>MDMA, more commonly known as <b>molly or ecstasy</b>, is a synthetic drug which is a <b>combination of stimulants and hallucinogens</b>, with an effect of up to 3-6 hours.  It is popular in the nightclub scene and at all-night dance parties <b>(known as “raves”)</b>.
                        </p>
                        <p>
                            It is usually <b>taken as a capsule of tablet</b>. Molly often refers to “pure” powder form of MDMA, but people purchasing it often get other drugs such as synthetic “bath salts” which can be extremely harmful.
                        </p>
                        <h4>
                            Short term effects include
                        </h4>
                        <ul style={{fontSize:"large"}}>
                            <li>Increased energy/activity that reinforces drug taking behaviours (due to dopamine release)</li>
                            <li>Increases heart rate and BP (due to norepinephrine release)</li>
                            <li>Affects mood, appetite, sleep; can also lead to sexual arousal (due to serotonin release)</li>
                            <li>Nausea</li>
                            <li>Muscle cramps, involuntary teeth clenches</li>
                            <li>Blurred vision</li>
                            <li>Chills and sweating</li>

                        </ul>

                        <h4>
                            Long term effects include
                        </h4>
                        <ul style={{fontSize:"large"}}>
                            <li>Irritability</li>
                            <li>    Impulsiveness or aggression</li>
                            <li>    Depression, anxiety</li>
                            <li>    Disrupted sleep patterns</li>
                            <li>    Memory and attention problems</li>
                            <li>    Decreased appetite</li>
                            <li>    Decreased interest in and pleasure from sex</li>
                            <li>    Kidney, liver damage</li>
                            <li>Risk of HIV/AIDS, Hepatitis due to risky sexual behaviour</li>

                        </ul>
                    </div>
                </div>
            </div>
        )
    }
}

export default MDMA;